// extracted by mini-css-extract-plugin
module.exports = {"upgradeSubscription":"_5iT1D8","title":"b7fMtR","desc":"_38c4Zg","picture":"_1tTLm0"};